import { clearAllSessionFilesV2 } from '@ublend-npm/aula-editor';
import * as types from '../../constants/actions';

export const resetFileScanStatus = (id, s3Key) => ({
  type: types.FILE_SCAN_RESET,
  payload: { id, s3Key },
});

export const resetAllFileScanStatuses = () => (dispatch) => {
  clearAllSessionFilesV2();
  return dispatch({
    type: types.RESET_FILE_SCAN_STATUS,
  });
};
